/**
 * Create reducers for toggling an attribute.
 *
 * @param {String} type  Action type
 * @return {Function} reducer
 */

export default (type, initialState) => (state = initialState, action) => {
  return type === action.type ? !state : state
}



// WEBPACK FOOTER //
// ./reducers/utils/create-toggle-reducer.js